module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/edit-btn/edit-btn.scss
// module id = ./web/modern/components/buttons/edit-btn/edit-btn.scss
// module chunks = 0